/** @jsxImportSource @emotion/react */

import { css, keyframes } from '@emotion/react'
import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import { useColors } from '../../packages/kiti/components/theme/_hooks/colors'
import Center from '../../packages/kiti/components/helpers/Center'
import Icon from '../../packages/kiti/components/shapes/Icon'
import IconText from '../../packages/kiti/components/presentation/IconText'
import Link from '../actions/Link'
import ListItemWrapper from '../list/ListItemWrapper'
import Text from '../../packages/kiti/components/presentation/Text'
import Tooltip from '../helpers/Tooltip'

export const sideMenuWidth = 4

export const SideMenuSubItem = ({ icon, label, children, iconSize, color, ...props }) => {
  const colors = useColors()

  return (
    <Link {...props}>
      <ListItemWrapper>
        {children || <IconText icon={icon} label={label} color={color || colors.dark3} iconSize={iconSize || 1.2} />}
      </ListItemWrapper>
    </Link>
  )
}

export const SideMenuItem = ({
  icon,
  noTooltipPadding,
  label,
  tooltip,
  children,
  top,
  bottom,
  noPaddingBottom,
  highlight = false,
  ...props
}) => {
  const colors = useColors()

  const pulse = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0);
  }
`

  const animation = highlight
    ? css`
        ${pulse} 2s infinite
      `
    : css`none`

  const style = css`
    width: ${sideMenuWidth}rem;
    padding: 0.65rem 0;
    ${noPaddingBottom ? 'padding-bottom: 0;' : ''}
    display: block;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: ${animation};
      pointer-events: none;
    }
  `

  return (
    <Link className="sideMenuItem" css={style} {...props}>
      <Tooltip
        actionContent={<Center>{children || <Icon size={1.2} name={icon} color={colors.white} />}</Center>}
        left="4rem"
        padding=".5rem"
        top={top || '-1rem'}
        bottom={bottom || '-1rem'}
        noPadding={noTooltipPadding}
        disableLazyClose={!tooltip}
      >
        {tooltip || <Text>{label}</Text>}
      </Tooltip>
    </Link>
  )
}

const SideMenu = ({ children, footer }) => {
  const colors = useColors()
  const style = css`
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: ${sideMenuWidth}rem;
    background: ${colors.menu || colors.dark1};
    border-right: solid 0px ${colors.light2};
    padding: 1rem 0;
  `

  return (
    <div css={style} className="sideMenu">
      <Grid direction="column" align="center" justify="space-between" height="100%">
        <Col flex={1}>{children}</Col>
        <Col>{footer}</Col>
      </Grid>
    </div>
  )
}

export default SideMenu
